<script>
import { page } from '$app/state'
import { WebflowFooter } from '$lib/components/webflow'
import { onMount } from 'svelte'
import { initForm } from '@formspree/ajax'

onMount(() => {
  initForm({ formElement: '#contact-form', formId: 'maqlkkgk' })
})

const contactJsonLd = $derived({
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Contact',
  description:
    'Contact IMX Data to access healthcare datasets, request a demo, or explore custom data solutions for financial modeling and investment research.',
  url: new URL('/contact', page.url.origin).href,
  inLanguage: 'en',
  about: {
    '@type': 'Organization',
    name: 'IMX Data, LLC',
    url: page.url.origin,
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.imxresearch.com/webflow/images/logo-v2-wht.svg',
    },
    sameAs: ['https://www.linkedin.com/company/imx-data/'],
    contactPoint: { '@type': 'ContactPoint', contactType: 'customer service' },
  },
})

const contactJsonLdScript = $derived(
  '<script type="application/ld+json">' + JSON.stringify(contactJsonLd) + '<\/script>',
)
</script>

<svelte:head>
  <title>Contact</title>
  <meta
    name="description"
    content="Contact IMX Data to access healthcare datasets, request a demo, or explore custom data solutions for financial modeling and investment research."
  />
  <meta property="og:title" content="Contact" />
  <meta
    property="og:description"
    content="Contact IMX Data to access healthcare datasets, request a demo, or explore custom data solutions for financial modeling and investment research."
  />
  <meta
    property="og:image"
    content="https://www.imxresearch.com/webflow/images/IMX-Data---Banner-1.jpg"
  />
  <meta name="twitter:title" content="Contact" />
  <meta
    name="twitter:description"
    content="Contact IMX Data to access healthcare datasets, request a demo, or explore custom data solutions for financial modeling and investment research."
  />
  <meta property="og:type" content="website" />
  <meta name="twitter:card" content="summary_large_image" />
  {@html contactJsonLdScript}
</svelte:head>

<section class="heading-section">
  <div class="container-large">
    <div class="grid-2-column">
      <div class="header-content">
        <h1 data-w-id="05c97b58-b1ac-eabe-afbc-3861dce3b03f" class="heading extra-large">
          <span class="text-gradient-overlay medium-2">Get in touch with the IMX team.</span>
        </h1>
      </div>
      <div class="form-block w-form">
        <div class="success-message alternate w-form-done" data-fs-success>
          <div>Thank you, your submission has been received</div>
        </div>
        <div class="error-message w-form-fail" data-fs-error>
          <div class="text-block">Something went wrong, please try again</div>
        </div>
        <form
          id="contact-form"
          name="wf-form-Contact-Form"
          data-name="Contact Form"
          method="post"
          class="login-form"
        >
          <input
            class="w-input text-input"
            maxlength="256"
            name="Name"
            placeholder="Name"
            type="text"
            id="Name"
            required
            data-fs-field
          />
          <input
            class="w-input text-input"
            maxlength="256"
            name="Email"
            placeholder="Email address"
            type="email"
            id="Email"
            required
            data-fs-field
          />
          <span data-fs-error="Email"></span>
          <textarea
            id="Message"
            name="Message"
            maxlength="5000"
            placeholder="Your message"
            required
            class="area w-input text-input"
            data-fs-field
          ></textarea>
          <span data-fs-error="Message"></span>
          <div class="spacer-4"></div>
          <button
            type="submit"
            class="button full-width w-button"
            data-fs-submit-btn
          >Send message</button>
        </form>
      </div>
    </div>
  </div>
</section>
<WebflowFooter />
